import { createStore } from "owa-satcheljs";

export interface ReplyNudgeStore {
    wasDismissed: boolean;
    needsReplyCount: number;
}

const getStore: () => ReplyNudgeStore = createStore<ReplyNudgeStore>("ReplyNudgeStore", {
    wasDismissed: false,
    needsReplyCount: 0,
});

export default getStore;
